<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-list-tile v-on="on">
        <v-list-tile-title>{{ $t('buttons.suggestedImages') }}</v-list-tile-title>
      </v-list-tile>
    </template>

    <v-card :color="$style.card.background">
      <CardToolbar :title="$t('pageHeader.suggestedImages')" :isModal="true" @cancel="cancel" />
      <v-container grid-list-lg class="image-box">
        <v-layout row wrap>
          <v-flex
            xs6
            v-for="(item, index) in filterList"
            :key="index"
            @click="selectImage(item)"
            class="pointer"
          >
            <div class="text-xs-center">
              <v-img :src="item.url" contain aspect-ratio="1.3333"></v-img>
              <span class="text-capitalize">{{ item.name }}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>

      <v-card-actions class="cardAction">
        <div>{{filterList.length}}</div>
        <v-spacer></v-spacer>
        <v-btn color="info" text @click="cancel">{{ $t('buttons.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
	name: 'image-selection',
	props: ['images'],
  data() {
    return {
      dialog: false,
      search: '',
      list: [],
    };
	},
	watch: {
		images(val) {
			if(val) {
				this.list = []
				this.setList()
			}
		}
	},
	created() {
		if (this.images) {
			this.setList()
		}
	},
  computed: {
		getImages() {
			return this.images
		},
    filterList() {
			return this.list
    },
  },
  methods: {
		setList() {
			if (this.images) {
				this.list = this.images
			}
			// if (this.images.imgUrl1 && this.images.imgUrl1.length > 0) this.list.push({ url: this.images.imgUrl1 })
			// if (this.images.imgUrl2 && this.images.imgUrl2.length > 0) this.list.push({ url: this.images.imgUrl2 })
			// if (this.images.imgUrl3 && this.images.imgUrl3.length > 0) this.list.push({ url: this.images.imgUrl3 })
			// if (this.images.imgUrl4 && this.images.imgUrl4.length > 0) this.list.push({ url: this.images.imgUrl4 })
			// if (this.images.imgUrl5 && this.images.imgUrl5.length > 0) this.list.push({ url: this.images.imgUrl5 })
		},
    selectImage(item) {
			if (item && item.url) {
				this.$emit('selected', item.url);
			}
      this.cancel();
    },
    cancel() {
			this.$emit('canceled', false);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.v-dialog__container {
  display: none !important;
}

.image-box {
  overflow: auto;
  height: 600px;
}
</style>
